export default {
  name: 'CancelamentoContrato',
  props: {
    pedidoCancelamento: {
      type: Boolean,
      required: true,
      default: false
    },
    resumoContrato: [Array, Object],
    modalVerificaCancelamento: {
      type: [Object]
    }
  },
  data: () => {
    return {
      mensagemBotaoCancelamento: '',
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      }
    }
  },
  computed: {
  },
  mounted () {
    if (this.pedidoCancelamento) {
      this.mensagemBotaoCancelamento = 'Pedido de cancelamento já solicitado'
    }
  },
  methods: {
    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    }
  }
}
